module.exports = __webpack_public_path__ + "dd4781d1acc57ba4c4808d1b44301201.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css/ionicons/fonts/ionicons.ttf
// module id = 301
// module chunks = 1